@if (showTitle == true) {
  <div>
    <app-page-header title="function.Businesses" translateTitle="yes" icon="store"></app-page-header>
  </div>
}
<div [ngClass]="organizationId ? '' : 'page-content'">

  @if (!organizationId) {
    <div class="flex-row flex-col-ltsm gap-col-1em" >
      @if (!fixedView) {
        <mat-form-field class="flex-1">
          <mat-label>Välj vy</mat-label>
          <mat-select [(value)]="currentViewId" (selectionChange)="$event? viewChanged($event) : null">
            @for (currentView of availableViews | async; track currentView) {
              <mat-option [value]="currentView.viewId">
                {{ currentView.viewName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field class="flex-1">
        <input [(value)]="currentSearchText" matInput (keyup)="applyFilter($event.target.value)" placeholder="{{'globalTexts.SearchInstruction' | translate}}">
      </mat-form-field>
    </div>
  }

  <div [ngClass]="organizationId ? '' : 'mat-elevation-z8'">
    @if (loadingIndicator) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Verksamhetsnamn </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Aktiv </mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.enabled | boolYesNoTranslator }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="businessCategoryName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Verksamhetskategori </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.businessCategoryName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="regionName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Region </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.regionName}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Skapad </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.createdDate | dateFormatter:true }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="updatedDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Ändrad </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.updatedDate | dateFormatter:true }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="flex-100px justify-center">
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="flex-100px justify-center">
          <button mat-icon-button matTooltip="{{'commands.Edit' | translate}}" [routerLink]="['/businesses/business', row.businessId]">
            <mat-icon>edit</mat-icon>
          </button>
          @if (hasPermissionToDelete()) {
            <button mat-icon-button  matTooltip="{{'commands.Delete' | translate}}" (click)="confirmDelete(row)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>

    @if (!organizationId) {
      <mat-paginator hidePageSize="true" pageSize="15" [pageSizeOptions]="[5, 10, 25, 100]" class="customPaginator"></mat-paginator>
    }

    @if (hasPermissionToChange()) {
      <section class="button-container">
        <button mat-fab color="primary" matTooltip="{{'commands.Add' | translate}}" (click)="gotoBusinessDetails()"><mat-icon>add</mat-icon></button>
      </section>
    }

  </div>
</div>
